import { roundPrice, vatPrice } from '../../../../../Greativ/helper/price'
import { computed, reactive, readonly, toRefs } from 'vue'
import { httpInstance } from './http'
import { setGlobalMessage, setSettings } from '@/stores/basket'
import { setTransport } from './transport'
import {
  shopAnalyticsAddToBasket,
  shopAnalyticsRemoveFromBasket,
} from '../../../../../Greativ/shop/analytics'

const state = reactive({
  products: [],
})

export function setProducts(products) {
  state.products = products
}

export const products = readonly(toRefs(state).products)

export const productsTotalPrice = computed(() => {
  let price = 0
  state.products.forEach((product) => {
    if (product.extraDiscount !== null) {
      price += product.extraDiscount * product.amount
    } else {
      price += (product.discountPrice || product.price) * product.amount
    }
  })

  return price
})

export const productsTotalVatPrice = computed(() => {
  let price = 0
  state.products.forEach((product) => {
    if (product.extraDiscount !== null) {
      price +=
        roundPrice(vatPrice(product.extraDiscount, product.vat)) *
        product.amount
    } else {
      price +=
        roundPrice(
          vatPrice(product.discountPrice || product.price, product.vat)
        ) * product.amount
    }
  })

  return price
})

export const productsTotalVat = computed(() => {
  let vat = 0
  state.products.forEach((product) => {
    if (product.extraDiscount !== null) {
      vat +=
        roundPrice(
          vatPrice(product.extraDiscount, product.vat) - product.extraDiscount
        ) * product.amount
    } else {
      vat +=
        roundPrice(
          vatPrice(product.discountPrice || product.price, product.vat) -
            (product.discountPrice || product.price)
        ) * product.amount
    }
  })

  return vat
})

export async function updateProduct(uID, amount = 1) {
  try {
    const {
      data: { items, transport, success, message, basket },
    } = await httpInstance.post('item', {
      uID,
      amount,
    })

    if (success) {
      setProducts(items)
      setTransport(transport)
      setSettings(basket)

      items.forEach((item) => {
        if (item.uID === uID) {
          shopAnalyticsAddToBasket({
            ...item,
            amount,
          })
        }
      })
    } else if (!success && message) {
      setGlobalMessage(message)
    }
  } catch (error) {
    console.error(error)
  }
}

export async function removeProduct(uID) {
  try {
    const oldProductIndex = state.products.findIndex(
      (product) => product.uID === uID
    )
    let oldProduct = null
    if (oldProductIndex > -1) {
      oldProduct = state.products[oldProductIndex]
    }

    const {
      data: { items, transport, success, message, basket },
    } = await httpInstance.post('removeItem', {
      uID,
    })

    if (success) {
      setProducts(items)
      setTransport(transport)
      setSettings(basket)
      if (oldProduct) {
        shopAnalyticsRemoveFromBasket(oldProduct)
      }
    } else if (!success && message) {
      setGlobalMessage(message)
    }
  } catch (error) {
    console.error(error)
  }
}

export const anyLockedProducts = computed(() => {
  let anyLocked = false

  state.products.forEach((product) => {
    if (product.locked) {
      anyLocked = true
    }
  })
  return anyLocked
})
